import { Button, Modal } from 'antd'
import React, { useState, type JSX } from 'react'
import styled from 'styled-components'

import { Frost } from './Frost'

const StyledModal = styled(Modal)`
  border-radius: 16px;

  .ant-modal-content {
    border-radius: 16px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
  }

  .ant-modal-body {
    height: 80vh;
    position: relative;
  }
`

const StyledLandscapeIframe = styled(Frost)`
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 16px;
`

export const PreviewButton = ({ client, customFields, ...rest }: any): JSX.Element => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button onClick={() => setOpen(true)} {...rest} />
      <StyledModal bodyStyle={{ padding: 0 }} footer={null} onCancel={() => setOpen(false)} open={open} width="90vw">
        <StyledLandscapeIframe client={client} customFields={customFields} />
      </StyledModal>
    </>
  )
}
